// main api end point, all the calls refer to this to get URL
// if adding new server create a new call here and add the new URL to the .env
import axios from "axios";
export default axios.create({
  baseURL: process.env.API,
  headers: {
    "Content-type": "application/json",
  },
});
